module.exports = __webpack_public_path__ + "img/game.5856a1c4.png";